"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginRequestUI = void 0;
var _ramda = require("ramda");
var _selectors = require("../../../../../../../../../bus/ui/selectors");
var _constants = require("./constants");
var getLoginRequestUI = exports.getLoginRequestUI = (0, _ramda.partialRight)(_selectors.getUI, [{
  key: _constants.LOGIN_REQUEST_UI
}]);